import { Container, ErrorBlock } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import {
    AddressPage,
    BasisTypesPage,
    CalendarPage,
    CheckoutPage,
    CompanyLeadPage,
    CompanyProductPickPage,
    DetailsPage,
    ErrorPage,
    KlippeKortPage,
    ModifyBookingPage,
} from '../../components'
import NoPartnerAvailablePage from '../../components/error/nopartneravailable'
import { StateComponentSwitcherProps } from './props'
import { useBFSM } from '../../contexts/bfsmContext'
import AdminCancelBook from '../../components/admincancelbook/admincancelbook.page'
import AdminConfirmCancellationPage from '../../components/adminconfirmcancellation/adminconfirmacancellation.page'

const StateComponentSwitcher = ({
    state,
}: StateComponentSwitcherProps): JSX.Element => {
    const { t } = useTranslation()

    switch (state) {
        case 'ADDRESS':
            return <AddressPage />
        case 'BASISTYPE':
            return <BasisTypesPage />
        case 'COMPANY':
            return <CompanyLeadPage />
        case 'COMPANY_PRODUCT_PICK_STATE':
            return <CompanyProductPickPage />
        case 'PACKAGE':
            return <KlippeKortPage />
        case 'CALENDAR':
            return <CalendarPage />
        case 'MOVEBOOKING':
            return <ModifyBookingPage />
        case 'DETAILS':
            return <DetailsPage />
        case 'CHECKOUT':
            return <CheckoutPage />
        case 'NOT_AVAILABLE':
            return <NoPartnerAvailablePage />
        case 'CANCEL_BOOKING_ADMIN_STATE':
            return <AdminCancelBook />
        case 'CONFIRM_CANCELLATION_ADMIN_STATE':
            return <AdminConfirmCancellationPage />
        case 'ERROR_STATE':
            return <ErrorPage />
        default:
            return (
                <Container>
                    <ErrorBlock errorText={t('common:error.default')} />
                </Container>
            )
    }
}

export { StateComponentSwitcher }
